import { Skeleton } from 'ui/skeleton';
import { GridRow } from 'ui/indexPages/tables/grid';

export const SkeletonRow = ({
  tableGrid,
  skeletonColumnCount,
}: {
  tableGrid: string;
  skeletonColumnCount: number;
}) => (
  <GridRow gridLayout={tableGrid} data-test="experiments-index-table-loading">
    {[...Array(skeletonColumnCount)].map((_, i) => (
      <Skeleton key={i} height={50} shimmerSpeed={2500} />
    ))}
  </GridRow>
);
